import { render, staticRenderFns } from "./survey-doughnut.vue?vue&type=template&id=dc4142dc&"
import script from "./survey-doughnut.vue?vue&type=script&lang=js&"
export * from "./survey-doughnut.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports